// utils
import get from 'lodash.get';
import { isString } from '~/utils';

export type GA = {
  getSessionId(): Promise<undefined | string>;
};

export default defineNuxtPlugin<{ ga: GA }>({
  name: 'ga',
  dependsOn: ['gtag'],
  setup: ({ $gtag, payload: { config } }) => {
    const getSessionId: GA['getSessionId'] = async () => {
      return new Promise(resolve => {
        const gaId = get(config, 'public.GA_ID');

        if (!isString(gaId)) {
          return resolve(undefined);
        }

        ($gtag as Gtag.Gtag)('get', gaId, 'session_id', value => {
          if (isString(value)) {
            return resolve(value);
          }

          resolve(undefined);
        });
      });
    };

    return {
      provide: {
        ga: {
          getSessionId,
        },
      },
    };
  },
});
